<template>
  <div
    v-editable="blok"
    class="QuoteBlock desktopMaxW-full"
    :class="desktopWidth('md')"
  >
    <div
      class="flex desk:items-center"
      :class="{
        'desk:flex-row-reverse': blok.leftAlignedContent,
        'flex-col desk:flex-row': !blok.smallImage,
        'flex-row': blok.smallImage,
        'bg-brandDark': blok.colorTheme === 'green',
        'bg-lighter': blok.colorTheme === 'grey',
      }"
    >
      <div
        v-if="blok.image && blok.image.filename"
        :class="{
          'w-1/3 desk:w-1/2': blok.smallImage,
          'desk:w-full': !blok.smallImage,
        }"
      >
        <nuxt-img
          preset="standard"
          loading="lazy"
          sizes="sm:100vw desk:1260px"
          class="h-full w-full object-cover"
          :src="blok.image.filename"
          :alt="blok.image.alt"
        />
      </div>
      <div
        class="w-full"
        :class="{
          'w-2/3 desk:w-full': blok.smallImage,
        }"
      >
        <div
          class="flex flex-col"
          :class="{
            'items-center text-center py-48 desk:py-64 px-12 desk:px-64 w-full': !blok.smallImage,
            'px-12 py-24 desk:px-64 desk:text-center desk:items-center': blok.smallImage,
          }"
        >
          <img
            src="/icons/quote.svg"
            alt="Quote"
            :class="{
              'w-48 mb-16 desk:mb-24': !blok.smallImage,
              'w-32 desk:w-48 mb-8 desk:mb-24': blok.smallImage,
            }"
          >
          <div
            :class="{
              'type-headline-lg desk:type-headline-xl mb-16': !blok.smallImage,
              'type-headline-sm desk:type-headline-xl mb-8 desk:mb-16': blok.smallImage,
              'text-lighter': blok.colorTheme === 'green',
              'bg-lighter': blok.colorTheme === 'grey',
            }"
          >
            {{ blok.quote }}
          </div>
          <div
            v-if="blok.author"
            class="leading-single text-dark"
            :class="{
              'type-sm': !blok.smallImage,
              'type-xs desk:type-sm': blok.smallImage,
              'text-lighter': blok.colorTheme === 'green',
            }"
          >
            {{ blok.author }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { StoryBlokAsset, StoryBlokPropBase } from '#constants/types/storyblok';

import useDesktopWidth from '~/composeables/useDesktopWidth';

type Props = StoryBlokPropBase & {
  quote: string;
  author: string;
  image: StoryBlokAsset;
  smallImage: boolean;
  leftAlignedContent: boolean;
  colorTheme: '' | 'default' | 'grey' | 'green',
}

const props = defineProps<{
  blok: Props,
}>();

const { desktopWidth } = useDesktopWidth(props);
</script>
